import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	itemGroup: {
		...theme.typography.link1,
	},
}));
